import { Reveal } from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

export const Gallery = () => {
  const { content } = useContent();
  const GALLERY = content.gallery;
  return (
    <section id="gallery" data-testid="gallery" className="bg-[#f4f1ea] px-6 py-28 lg:px-10 lg:py-40">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <div>
              <div className="overline mb-6">Gallery</div>
              <h2 className="max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight text-[#23281f] lg:text-6xl">
                A peek <span className="italic text-[#ba5a45]">inside Aruha.</span>
              </h2>
            </div>
            <p className="max-w-sm text-[#5c6157]">
              Moments from the trail and the table — captured in the heart of the Garhwal Himalaya.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-12 lg:gap-6">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className={`group relative overflow-hidden ${g.cls || "lg:col-span-4 aspect-square"}`}>
              <img
                src={g.src}
                alt={g.caption || "Aruha gallery"}
                style={{ objectPosition: g.focal }}
                className="img-zoom h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1f18]/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              {g.caption && (
                <span className="absolute bottom-4 left-4 translate-y-2 font-serif text-lg italic text-[#f6f3ec] opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  {g.caption}
                </span>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Testimonial = () => {
  const { content } = useContent();
  const t = content.testimonial;
  return (
    <section data-testid="testimonial" className="bg-[#2b3a2e] px-6 py-28 lg:px-10 lg:py-36">
      <div className="mx-auto max-w-4xl text-center">
        <Reveal>
          <div className="mb-8 text-5xl text-[#e7d2ad]">“</div>
          <blockquote className="font-serif text-3xl font-light leading-snug tracking-tight text-[#f6f3ec] lg:text-5xl">
            {t.quote}
          </blockquote>
          <div className="mt-10 text-sm uppercase tracking-[0.2em] text-[#cdd3c8]">{t.author}</div>
        </Reveal>
      </div>
    </section>
  );
};
